import React from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Box, ModalFooter, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import FormInput from '../../../../../components/form/FormInput';
import SingleOptionButton from '../../../../../components/Modal/ModalButtonGroups/SingleOptionButton';
import { CypressIds } from '../../../../../constants/cypressIds';
import { hideModal } from '../../../../../redux/modules/modal';
import { globalRequirementTemplateBuilder } from '../../../../../redux/reducer';
import colors from '../../../../../styles/theme/foundation/colors';

const CreateUpdateFolderModal = ({ folderId, description }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { location } = history;
  const folders = useSelector(globalRequirementTemplateBuilder.selectRequirementTemplateFolders).data;

  const getFolderName = () => {
    if (folderId) {
      const folder = folders.length && folders.find(f => f.id === parseInt(folderId, 10));
      return { folderName: folder?.name };
    }
  };

  const useFormMethods = useForm({ defaultValues: getFolderName() });
  const { handleSubmit, control } = useFormMethods;
  const { isSubmitting } = useFormState({ control });

  const onSubmit = async data => {
    if (folderId) {
      await dispatch(globalRequirementTemplateBuilder.updateRequirementTemplateFolder(folderId, { name: data.folderName }));

      dispatch(globalRequirementTemplateBuilder.listRequirementTemplateFolders());
    } else {
      const newFolder = await dispatch(globalRequirementTemplateBuilder.createRequirementTemplateFolder({ name: data.folderName }));

      const basePath = location.pathname.slice(0, location.pathname.indexOf('requirement'));
      const newPathname = basePath.concat(`requirement-templates/${newFolder.id.toString()}`);
      history.push(newPathname);
    }

    dispatch(hideModal());
  };

  return (
    <>
      <Box>
        <Text color={colors.greyScale['500']} mb={7} textAlign="center" textStyle="bodySm">
          {description}
        </Text>
        <form id="createNewFolder" onSubmit={handleSubmit(onSubmit)}>
          <Box height="90px">
            <FormInput
              required
              cypressId={CypressIds.reqTemplatesCreateNewFolderInput}
              inputName="folderName"
              labelName="Folder Name"
              placeholder="New Folder"
              useFormMethods={useFormMethods}
              validationRules={
              {
                required: { value: true, message: 'Folder Name is required' },
                minLength: { value: 2, message: 'Must include at least two characters' },
                maxLength: { value: 32, message: 'Must contain fewer than 32 characters' }
              }
            }
            />
          </Box>
        </form>
      </Box>
      <ModalFooter justifyContent="center">
        <SingleOptionButton
          cypressId={CypressIds.reqTemplatesCreateNewFolderSubmitButton}
          dataAnalyticsId="update-create-template-folder"
          formId="createNewFolder"
          isLoading={isSubmitting}
          label="Save Folder"
          type="submit"
        />
      </ModalFooter>
    </>
  );
};

CreateUpdateFolderModal.propTypes = {
  /** Existing folder ID, required for updating folder name */
  folderId: PropTypes.number,
  /** Descriptive text for body of modal */
  description: PropTypes.string
};

export default CreateUpdateFolderModal;
